import { StowagePlan } from 'src/types/ViewModel/Stowage/StowagePlan';
import PageHeaderStowagePlanItem from './PageHeaderStowagePlanItem';
import { getStowagePlanType } from 'src/utils/stowage/stowagePlanUtils';
import { ReactNode } from 'react';
import { StowagePlanListItemTitle, StowagePlanListItemRow } from './PageHeaderStowage.style';

interface StowagePlanListItemProps {
    stowagePlan: StowagePlan;
    onClick?: (event: any, plan: StowagePlan) => void;
    isSelected?: boolean;
}

const PageHeaderStowagePlanListItem = ({ stowagePlan, onClick, isSelected }: StowagePlanListItemProps): ReactNode => {
    if (!stowagePlan) return <StowagePlanListItemTitle>No master plan for this vessel...</StowagePlanListItemTitle>;

    const stowagePlanType = getStowagePlanType(stowagePlan);

    return (
        <StowagePlanListItemRow className="dd-item" $isSelected={isSelected} key={stowagePlan.stowagePlanGuid} onClick={(e) => onClick && onClick(e, stowagePlan)}>
            <PageHeaderStowagePlanItem stowagePlan={stowagePlan} stowagePlanType={stowagePlanType} />
        </StowagePlanListItemRow>
    );
};

export default PageHeaderStowagePlanListItem;
